module.exports = __webpack_public_path__ + "static/media/tn.e1d69255.svg";